import API from "api/api/API";
import Cookies from "js-cookie";
import TenantAPI from "./TenantAPI";
export default class PageAPI {
  static async createPage(workspaceID, payload) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updatePage(workspaceID, pageID, payload) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updatePageSettings(workspaceID, pageID, payload) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/settings`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async deletePage(workspaceID, pageID, isApp) {
    return API._bearerRequest(
      "delete",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}`,
      { isApp },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async duplicatePage(workspaceID, pageID) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/duplicate`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  // ------------------------------------ Page User Management -------------------------------------------
  static async addPageUser(workspaceID, pageID, PersonID, PermissionProfile) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/users`,
      { PersonID, PermissionProfile },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updatePageUser(
    workspaceID,
    pageID,
    PersonID,
    PermissionProfile
  ) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/users/${PersonID}`,
      { PermissionProfile },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async deletePageUser(workspaceID, pageID, PersonID) {
    return API._bearerRequest(
      "delete",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/users/${PersonID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async transferPageOwnership(
    workspaceID,
    pageID,
    userID,
    currentOwnerID,
    newPermissions
  ) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/transfer-ownership/users/${userID}`,
      { currentOwnerID: currentOwnerID, PermissionProfile: newPermissions },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async bulkdPageUsers(workspaceID, pageID, payload) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/users/operation/bulk`,
      payload,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  // ----------------------------------- Page Fetching -------------------------------------------
  static async getPageByID(workspaceID, pageID) {
    return API._bearerRequest(
      "get",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getPagesByIds(workspaceID, pageIds) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages/getMany`,
      { Pages: pageIds },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  // Used to tranfer a page from one workspace into another.
  static async transferPage(workspaceID, pageID, newWorkspaceID) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/transfer/${newWorkspaceID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  // ------------------------------------ Views -------------------------------------------
  static async createView(workspaceID, pageID, payload, parentViewID) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views`,
      { payload, parentViewID },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getViewByID(workspaceID, pageID, viewID) {
    return API._bearerRequest(
      "get",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${viewID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async getSubviews(workspaceID, pageID, parentViewID) {
    return API._bearerRequest(
      "get",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${parentViewID}/subviews`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updateView(workspaceID, pageID, viewID, payload, userActivity) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${viewID}`,
      { payload, _UserActivity: userActivity },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async deleteView(workspaceID, pageID, viewID) {
    return API._bearerRequest(
      "delete",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${viewID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async duplicateView(workspaceID, pageID, viewID) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${viewID}/duplicate`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async reorderSubviews(workspaceID, pageID, viewID, newOrder) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${viewID}/reorder`,
      { newOrder },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async updateSubView(
    workspaceID,
    pageID,
    viewID,
    payload,
    userActivity,
    parentViewID
  ) {
    return API._bearerRequest(
      "put",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${parentViewID}/subview/${viewID}`,
      { payload, _UserActivity: userActivity },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async deleteSubView(workspaceID, pageID, parentViewID, viewID) {
    return API._bearerRequest(
      "delete",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${parentViewID}/subview/${viewID}`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async duplicateSubView(workspaceID, pageID, parentViewID, viewID) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${parentViewID}/subview/${viewID}/duplicate`,
      null,
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async generateFlowChart(workspaceID, pageID, viewID, payload) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${viewID}/flowchart/generate`,
      { payload },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }

  static async generateFlowChartOnDemand(
    workspaceID,
    pageID,
    viewID,
    subviewID,
    payload
  ) {
    return API._bearerRequest(
      "post",
      `/tenant/workspaces/${workspaceID}/pages/${pageID}/views/${viewID}/flowchart/generate/on-demand/${subviewID}`,
      { payload },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
